import React from "react";
import { SearchX, Filter, X } from "lucide-react";
import { EDUSICO_COLORS } from "../../lib/colors";

interface FilterSuggestion {
  key: string;
  label: string;
  count: number;
  onClear: () => void;
}

interface EmptyStateProps {
  title?: string;
  description?: string;
  filters?: FilterSuggestion[];
}

export const EmptyState: React.FC<EmptyStateProps> = ({
  title = "No hay resultados",
  description = "Prueba ajustando los filtros para ver mas opciones.",
  filters,
}) => {
  const sortedFilters = filters
    ? [...filters].sort((a, b) => a.count - b.count)
    : [];

  const mostRestrictive = sortedFilters[0];

  return (
    <div
      className="flex flex-col items-center justify-center gap-4 p-8 text-center rounded-2xl"
      style={{
        backgroundColor: EDUSICO_COLORS.bgPanel,
        border: `1px dashed ${EDUSICO_COLORS.border}`,
      }}
    >
      <div
        className="w-12 h-12 rounded-xl flex items-center justify-center"
        style={{
          backgroundColor: EDUSICO_COLORS.bgMuted,
          color: EDUSICO_COLORS.textMuted,
        }}
      >
        <SearchX className="w-6 h-6" />
      </div>

      <div className="space-y-1">
        <p
          className="text-sm font-semibold font-sans"
          style={{ color: EDUSICO_COLORS.textMain }}
        >
          {title}
        </p>
        <p
          className="text-xs leading-relaxed font-sans max-w-xs"
          style={{ color: EDUSICO_COLORS.textMuted }}
        >
          {description}
        </p>
      </div>

      {mostRestrictive && (
        <div className="flex flex-col items-center gap-2 mt-1">
          <p
            className="text-[11px] font-sans"
            style={{ color: EDUSICO_COLORS.textLight }}
          >
            El filtro mas restrictivo es
            <span className="font-medium" style={{ color: EDUSICO_COLORS.accent }}>
              {mostRestrictive.label}
            </span>
            ({mostRestrictive.count} resultado
            {mostRestrictive.count === 1 ? "" : "s"})
          </p>
          <button
            onClick={mostRestrictive.onClear}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-[11px] font-sans font-medium transition-colors hover:opacity-90"
            style={{
              backgroundColor: EDUSICO_COLORS.bgMuted,
              color: EDUSICO_COLORS.textMain,
              border: `1px solid ${EDUSICO_COLORS.borderLight}`,
            }}
          >
            <Filter className="w-3 h-3" />
            Quitar {mostRestrictive.label}
            <X className="w-3 h-3" />
          </button>
        </div>
      )}
    </div>
  );
};
